var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-span',[_c('v-span',[_vm._v(_vm._s(_vm.imtDisplay))]),(_vm.keterangan)?_c('v-span',[_vm._v(" ("+_vm._s(_vm.keterangan)+")")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }